import { render, staticRenderFns } from "./Shoporder.vue?vue&type=template&id=2450e936&scoped=true&"
import script from "./Shoporder.vue?vue&type=script&lang=js&"
export * from "./Shoporder.vue?vue&type=script&lang=js&"
import style0 from "./Shoporder.vue?vue&type=style&index=0&id=2450e936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2450e936",
  null
  
)

export default component.exports